/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import autobind from "autobind-decorator";
import {service as ProgramBenefitSpreadsheetService} from "../../../Services/ProgramBenefitSpreadsheetService";
import {FileUploadFieldEditor} from "./FileUploadFieldEditor";

export class ProgramBenefitFileUploadFieldEditor extends React.Component {
	constructor(props) {
		super(props);
	}

	@autobind
	downloadBenefitSpreadsheet() {
		//if we don't have data. Lets just ship a blank template.
		let programEnvironmentalBenefitId = -1;
		let targetValue = this.props.Data.targetValue;
		// unfortunately this doesn't update when the input box changes
		// so this won't really propagate unsaved changes from this field
		let programLength = this.props.RootData.programLength;

		if (this.props.Data.programId) {
			//if we have an existing program id. Lets load that file.
			programEnvironmentalBenefitId = this.props.Data.programEnvironmentalBenefitId;
		}

		ProgramBenefitSpreadsheetService.DownloadFile("program_benefits_template.xlsx", programEnvironmentalBenefitId, targetValue, programLength);
	}

	render() {
		return <div>
			<FileUploadFieldEditor {...this.props} />

			<div className="top10">
				<a className="link-primary" onClick={this.downloadBenefitSpreadsheet}>Download Blank Template (.xls)</a>
			</div>
		</div>;
	}
}